import { render } from "./Summary_Overview.vue?vue&type=template&id=afbc289a"
import script from "./Summary_Overview.vue?vue&type=script&lang=js"
export * from "./Summary_Overview.vue?vue&type=script&lang=js"

import "./Summary_Overview.vue?vue&type=style&index=0&id=afbc289a&lang=scss"
script.render = render

export default script